import { render, staticRenderFns } from "./LoginHeader.vue?vue&type=template&id=0ece1fa8&"
import script from "./LoginHeader.vue?vue&type=script&lang=ts&"
export * from "./LoginHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports